<template>
  <select @change="show" ref="slect"  required id="country" name="country" class="form-control">
                <option disabled value="Location" selected>Location</option>
                <option value="Niger">Niger</option>
                <option value="Nigeria">Nigeria</option>
                <option value="Northern Mariana Islands">Northern Mariana Islands</option>
            </select>

            
</template>

<script>
export default {
name: 'Select',
methods:{
  show(){
    this.$emit('open', this.$refs.slect.value)
  }
}
}
</script>

<style>
select{
    margin: 10px 0px;
      border: 2px solid #EBEAED;
      background: white;
      outline: none;
      width:100%;
      border-radius: 10px;
        padding:13px 10px;
         font-family: 'DM Sans', sans-serif;
        overflow: hidden;
}
</style>